export default "/countdown-crate-no-bg.76194f6bd5e26a39bded718e6df837d0.png";